module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_okunai_sola-69009d90934722d1b9f6f43a20df5847.jpg";